import React,  { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';
import { useDispatch, useSelector } from "react-redux";
/**
 * 버튼
 */


const ButtonQuickText = ({ label, value, labelIcon, viewStatus, onClickEvt, contentLength, image, number, ariaLabelText, title }) => {

  const quickMenuStatus = useSelector(state => state.isActive.quickMenu);
  
  useEffect(() => {
    if(quickMenuStatus) {
      disabledTabMoveButton(['_btn_quick_txt_div', '_menu_btn','_icon_set','_quick_intro']);
      disabledTabMoveInput(['_send_box_input']);
    } else {
      fallbackTabMove();
    }
  }, [quickMenuStatus])

  return (
    <button className="_btn_quick_txt_div" onClick={onClickEvt} type='button' aria-label={ariaLabelText} aria-hidden={!quickMenuStatus} title={ariaLabelText}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_btn_div">
        <div className="_icon">
          {labelIcon !== 'ri-cloud-line' ? (
            <i className={labelIcon} />
          ) : (
            <div> {image.includes('<img') ? ReactHtmlParser(image) : <img src={image} alt="" />}</div>
          )}
        </div>
        <div className="_txt">{label}</div>
      </div>
    </button>
  );
};

ButtonQuickText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  labelIcon: PropTypes.string,
  image: PropTypes.string,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  number: PropTypes.number,
  contentLength: PropTypes.number,
  ariaLabelText: PropTypes.string,
  title: PropTypes.string,
};
ButtonQuickText.defaultProps = {
  label: '적용',
  value: '',
  image: '',
  labelIcon: 'ri-cloud-line',
  // styleDef: {},
  viewStatus: '',
  onClickEvt: () => {},
  // error: { error: false, msg: '' },
  number: 0,
  contentLength: 6,
  ariaLabelText: '',
  title:'',
};

export default ButtonQuickText;
